import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/checkbox.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import { hot } from 'react-hot-loader/root'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { VerticalSegment } from 'components/verticalSegment'
import { LocaleContext } from 'contexts/locale'
import { Statistics } from 'components/statistics'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Waypoint } from 'react-waypoint'
import config from 'config'
import { Footer } from '@ta-interaktiv/react-footer'
import { Cover } from 'components/cover'

/** Article ID */
const ARTICLE_ID = config.articleId
const ADDITIONAL_SHARES = 189

function AppComponent() {
  const [locale, setLocale] = useState<'de' | 'fr' | 'en'>('de')
  const domain = parseHostname().publicationDomain
  const IntroText = require('text/' + locale + '/intro.mdx').default

  // Get site language
  useEffect(() => {
    // Download language
    window
      .fetch(`https://m.${domain}/api/sites/default`)
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.status.toString())
      })
      .then(data => {
        setLocale(data.site.language)
      })
      .catch(error => {
        console.warn(error)
      })
  }, [domain, ARTICLE_ID])

  const messages = require(`./locales/${locale}.yml`)

  return (
    <div className='index'>
      <LocaleContext.Provider value={locale}>
        <ThemeSwitch />

        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
        <Cover />

        <VerticalSegment text className='grey'>
          <IntroText />
        </VerticalSegment>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: '25ContentRead'
              })
            }
          }}
        />

        <VerticalSegment text>
          <Statistics />
        </VerticalSegment>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: '75ContentRead'
              })
            }
          }}
        />

        <Footer
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
          credits={messages.credits}
          hideUserFeedback
        />
      </LocaleContext.Provider>
    </div>
  )
}

export const App = hot(AppComponent)
